module.exports = __webpack_public_path__ + "static/media/cu.7797b415.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cu.svg
// module id = 1018
// module chunks = 0